/* AUTO-GENERATED by shared-library/capabilities/zone-config-generator.
   Source: image-pipeline/blanks-normalized/*.json. Do NOT edit by hand —
   change the sidecar via engrave-zone-editor.html and re-run the generator. */
window.OTRK_ZONE_CONFIGS = {
  "barkeeper-tool": {
    "design-only": {
      "engrave": {
        "top": 43.41,
        "left": 33.06,
        "width": 28.32,
        "height": 13.09
      }
    },
    "text-only": {
      "text": {
        "top": 43.41,
        "left": 33.69,
        "width": 27.98,
        "height": 12.94
      }
    }
  },
  "glass-coin-holder": {
    "design-only": {
      "engrave": {
        "top": 22.31,
        "left": 19.38,
        "width": 61.52,
        "height": 56.93
      }
    },
    "with-text": {
      "engrave": {
        "top": 22.31,
        "left": 19.38,
        "width": 61.52,
        "height": 36.91
      },
      "text": {
        "top": 60.6,
        "left": 19.38,
        "width": 61.52,
        "height": 18.02
      }
    }
  },
  "metal-business-card-heavy": {
    "design-only": {
      "engrave": {
        "top": 31.54,
        "left": 12.3,
        "width": 75.39,
        "height": 37.06
      }
    },
    "with-text": {
      "engrave": {
        "top": 31.54,
        "left": 12.3,
        "width": 75.39,
        "height": 18.46
      },
      "text": {
        "top": 51.07,
        "left": 12.3,
        "width": 75.39,
        "height": 17.53
      }
    }
  },
  "metal-business-card-light": {
    "design-only": {
      "engrave": {
        "top": 27.98,
        "left": 12.94,
        "width": 74.32,
        "height": 44.14
      }
    },
    "with-text": {
      "engrave": {
        "top": 27.98,
        "left": 12.94,
        "width": 74.32,
        "height": 23.54
      },
      "text": {
        "top": 52.29,
        "left": 12.94,
        "width": 74.32,
        "height": 19.38
      }
    }
  },
  "metal-keychain-oval": {
    "design-only": {
      "engrave": {
        "top": 29.39,
        "left": 22.02,
        "width": 56.3,
        "height": 41.06
      }
    },
    "text-only": {
      "text": {
        "top": 29.39,
        "left": 22.17,
        "width": 56.3,
        "height": 41.06
      }
    }
  },
  "metal-lighter": {
    "design-only": {
      "engrave": {
        "top": 16.94,
        "left": 29.25,
        "width": 40.14,
        "height": 65.97
      }
    },
    "with-text": {
      "engrave": {
        "top": 43.07,
        "left": 29.25,
        "width": 40.14,
        "height": 39.84
      },
      "text": {
        "top": 16.94,
        "left": 29.25,
        "width": 40.14,
        "height": 22.61
      }
    }
  },
  "metal-pizza-cutter": {
    "design-only": {
      "engrave": {
        "top": 45.85,
        "left": 35.4,
        "width": 30.32,
        "height": 10.01
      }
    }
  },
  "metal-tag-small": {
    "design-only": {
      "engrave": {
        "top": 29.54,
        "left": 20.46,
        "width": 65.09,
        "height": 40.92
      }
    },
    "text-only": {
      "text": {
        "top": 29.69,
        "left": 20.17,
        "width": 66.16,
        "height": 40.14
      }
    }
  },
  "slate-coaster-round": {
    "design-only": {
      "engrave": {
        "top": 16.02,
        "left": 15.38,
        "width": 68.95,
        "height": 67.68
      }
    },
    "text-only": {
      "text": {
        "top": 25.24,
        "left": 23.83,
        "width": 53.52,
        "height": 50.78
      }
    }
  },
  "slate-coaster-square": {
    "design-only": {
      "engrave": {
        "top": 19.24,
        "left": 19.82,
        "width": 62.45,
        "height": 62.01
      }
    },
    "text-only": {
      "text": {
        "top": 19.09,
        "left": 19.68,
        "width": 62.79,
        "height": 62.3
      }
    }
  },
  "tumbler-24oz": {
    "design-only": {
      "engrave": {
        "top": 22.75,
        "left": 38.48,
        "width": 21.68,
        "height": 40.48
      }
    },
    "text-only": {
      "text": {
        "top": 22.75,
        "left": 38.62,
        "width": 22.02,
        "height": 49.22
      }
    },
    "with-text": {
      "engrave": {
        "top": 22.9,
        "left": 35.06,
        "width": 29.05,
        "height": 26.76
      },
      "text": {
        "top": 50.93,
        "left": 35.25,
        "width": 29.05,
        "height": 10.79
      }
    }
  },
  "tumbler-32oz": {
    "design-only": {
      "engrave": {
        "top": 17.82,
        "left": 31.54,
        "width": 35.25,
        "height": 27.83
      }
    },
    "text-only": {
      "text": {
        "top": 16.94,
        "left": 31.05,
        "width": 35.99,
        "height": 28.76
      }
    },
    "with-text": {
      "engrave": {
        "top": 18.16,
        "left": 31.25,
        "width": 36.13,
        "height": 15.87
      },
      "text": {
        "top": 34.77,
        "left": 31.69,
        "width": 35.4,
        "height": 10.45
      }
    }
  },
  "walnut-plank": {
    "design-only": {
      "engrave": {
        "top": 15.23,
        "left": 11.52,
        "width": 75.54,
        "height": 69.24
      }
    }
  },
  "wood-keychain-oval": {
    "design-only": {
      "engrave": {
        "top": 30.62,
        "left": 21.39,
        "width": 56.79,
        "height": 37.55
      }
    },
    "text-only": {
      "text": {
        "top": 30.91,
        "left": 20.61,
        "width": 58.45,
        "height": 36.91
      }
    }
  },
  "wood-live-edge": {
    "design-only": {
      "engrave": {
        "top": 27.1,
        "left": 27.83,
        "width": 45.36,
        "height": 46
      }
    },
    "text-only": {
      "text": {
        "top": 27.1,
        "left": 27.83,
        "width": 45.56,
        "height": 46.14
      }
    }
  },
  "wood-plaque-10x12": {
    "design-only": {
      "engrave": {
        "top": 21.24,
        "left": 9.38,
        "width": 81.05,
        "height": 57.71
      }
    },
    "with-text": {
      "engrave": {
        "top": 21.09,
        "left": 55.52,
        "width": 35.06,
        "height": 35.06
      },
      "text": {
        "top": 21.09,
        "left": 9.38,
        "width": 45.07,
        "height": 35.06
      },
      "design2": {
        "top": 56.79,
        "left": 9.38,
        "width": 81.05,
        "height": 22.31
      }
    }
  },
  "wood-rect-6x7": {
    "design-only": {
      "engrave": {
        "top": 9.38,
        "left": 25.39,
        "width": 48.44,
        "height": 79.98
      }
    },
    "with-text": {
      "engrave": {
        "top": 9.67,
        "left": 25.68,
        "width": 47.71,
        "height": 57.37
      },
      "text": {
        "top": 67.82,
        "left": 25.68,
        "width": 47.71,
        "height": 21.39
      }
    }
  },
  "wood-rect-8x10": {
    "design-only": {
      "engrave": {
        "top": 11.23,
        "left": 27.1,
        "width": 46.14,
        "height": 76.17
      }
    },
    "with-text": {
      "engrave": {
        "top": 11.23,
        "left": 27.1,
        "width": 45.85,
        "height": 57.23
      },
      "text": {
        "top": 69.24,
        "left": 27.1,
        "width": 45.85,
        "height": 18.75
      }
    }
  },
  "wood-round-10x10": {
    "design-only": {
      "engrave": {
        "top": 11.38,
        "left": 11.52,
        "width": 76.61,
        "height": 76.76
      }
    },
    "with-text": {
      "engrave": {
        "top": 25.54,
        "left": 21.53,
        "width": 57.86,
        "height": 44.48
      },
      "text": {
        "top": 14.94,
        "left": 29.05,
        "width": 42.14,
        "height": 8.94
      },
      "design2": {
        "top": 72.02,
        "left": 28.91,
        "width": 42.29,
        "height": 11.52
      }
    }
  },
  "wood-square-10x10": {
    "design-only": {
      "engrave": {
        "top": 9.86,
        "left": 10.45,
        "width": 79.39,
        "height": 77.83
      }
    },
    "with-text": {
      "engrave": {
        "top": 9.23,
        "left": 10.16,
        "width": 79.83,
        "height": 58.3
      },
      "text": {
        "top": 69.24,
        "left": 10.16,
        "width": 79.98,
        "height": 19.09
      }
    }
  }
};
